import { ReactNode, useEffect } from 'react';

import { useKeyImagesRetrieveQuery } from '@/api/queries';
import { useKeyImagesStore } from '@/store';

interface KeyImagesRefetchHandlerProps {
  children: ReactNode;
}

export function KeyImagesRefetchHandler({ children }: KeyImagesRefetchHandlerProps) {
  const { shouldRefetchKeyImages } = useKeyImagesStore();
  const { refetch } = useKeyImagesRetrieveQuery();

  useEffect(() => {
    if (shouldRefetchKeyImages) {
      refetch();
    }
  }, [shouldRefetchKeyImages, refetch]);

  return children;
}
